import { type ICianApiSiteV1SearchRegionsCitiesResponse } from '@/repositories/generated/shared/monolith-python/cian-api/site/v1/search-regions-cities';

import { type ILocation } from '@/microfrontends/filters/shared/types/location';

export function prepareSuggestions(response: ICianApiSiteV1SearchRegionsCitiesResponse): ILocation[] {
  return response.data.items || [];
}
